import styled from "styled-components";
import { GlobalWrapper, SectionWrapper } from "shared/Styles/Wrappers";

export const Container = styled(GlobalWrapper)`
  padding: 96px 0;
  background-color: ${({ color }) => (color ? color : "#fff")};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding: 64px 0;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    padding: 48px 0 0 0;
  }
`;

export const Wrapper = styled(SectionWrapper)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    justify-content: center;
    flex-wrap: wrap;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 48px;
`;

export const Icon = styled.img`
  width: 74px;
  height: 74px;
  object-fit: contain;
  object-position: center;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    width: 54px;
    height: 54px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    width: 25%;
    height: 28px;
  }
`;
